import { CreateAzureConfiguration } from '@/components/configuration/azure/create-configuration'
import { createFileRoute } from '@tanstack/react-router'

import { store } from '@/state/breadcrumb-store'
import { CreateAWSConfiguration } from '@/components/configuration/aws/create-landing-zone'
export const Route = createFileRoute(
  '/customer/$customerId/create/$configurationType',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { customerId, configurationType } = Route.useParams()
  if (configurationType == 'azure-unmanaged' || configurationType == 'azure-managed' || configurationType == 'aws-landing-zone') {

    store.trigger.changePath({
      newPath:
        [{ params: {}, to: "/customer", label: "Customer" },
        { params: { customerId: customerId }, to: "/customer/$customerId", label: customerId },
        { params: { configurationType: configurationType }, to: "/customer/$customerId/create/$configurationType", label: "Create" },
        ]
    })

    if (configurationType == 'aws-landing-zone') {
      return <CreateAWSConfiguration customerId={customerId} createType={configurationType}></CreateAWSConfiguration>
    }

    return <CreateAzureConfiguration customerId={customerId} createType={configurationType} />
  }
  return <span> No config form found</span>
}
